export const RECEIVE_INFOGRAPHICS_DATA = "RECEIVE_INFOGRAPHICS_DATA";
export const SHOW_LOADER = "SHOW_INFOGRAPHICS_SERVICE_LOADER";

export interface IInfographicsState {
    infographicsData?: InfographicsData[];
    isLoading: boolean;
}

export interface InfographicsData {
    title?: string;
    summary?: string;
    author?: string;
    feedUrl?: string;
    imageUrl?: string;
    publishDate?: string;
}

export interface GetInfographicsDataAction {
    type: "RECEIVE_INFOGRAPHICS_DATA";
    infographicsData: InfographicsData[];
}
export interface ShowAction {
    type: "SHOW_INFOGRAPHICS_SERVICE_LOADER";
    isLoading: boolean;
}

export type KnownAction = GetInfographicsDataAction | ShowAction;
